// extracted by mini-css-extract-plugin
export var category = "main-content-integration-module--category--bc5a6";
export var colTitle = "main-content-integration-module--colTitle--b06df";
export var disclaimer = "main-content-integration-module--disclaimer--b124e";
export var gridContainer = "main-content-integration-module--gridContainer--b7be9";
export var gridItem = "main-content-integration-module--gridItem--9ed37";
export var integrationCategory = "main-content-integration-module--integrationCategory--384ee";
export var integrationTableBody = "main-content-integration-module--integrationTableBody--27fd3";
export var oemSpan = "main-content-integration-module--oemSpan--d740e";
export var root = "main-content-integration-module--root--3fc5a";
export var table = "main-content-integration-module--table--61d8d";